import React, { Component } from "react";

import Botao from "../utils/Botao";

import PropTypes from 'prop-types';

class PontoInteresseSmall extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {};
  }

  POIClicked = () => {
    this.props.POIClicked(this.props.item.identifier);
    
  }

  stripHTMLTags = (text) => {
    console.log(text);
    if(text === null || text === ''){
      return '';
    }
    else{
      let description = text;
      
      description = description.replace(/<[^>]*>/g, '');
      description = description.replace(/(?:^|\W)&nbsp(?:$|\W)/, '');
      if(description.length > 500){
        description = description.substr(0, 500) + "\u2026";
      }
      return description;
    }
  }

  render() {
    return (
      <div onClick={this.POIClicked} id="ponto-interesse-small" className="row box-shadow">
        <div className="col-12 col-md-4 col-lg-3 no-padding ponto-interesse-small-image">
          <img alt="" src={this.props.item.mainPhoto}></img>
        </div>
        <div className="col-12 col-md-8 col-lg-9 ponto-interesse-list-details">
          <h4 className="ponto-interesse-list-title">{this.props.item.name}</h4>
          <p className="ponto-interesse-list-description">{this.stripHTMLTags(this.props.item.description)}</p>
          <Botao></Botao>
        </div>
      </div>
    );
  }
}

export default PontoInteresseSmall;
